import WebFont from 'webfontloader'

const options = {"google":{"families":["Nunito+Sans:300,400,700"]}}

WebFont.load(options)
